/** @format */

import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Environnement from "../Component/Dashboard/auth/Environnement";
import AdminHome from "../Component/Admin/Dashboard/default/AdminHome";
import DocViewer from "../Component/Dashboard/PLAN01/TabDocs/DocViewer";
import Import from "../Component/Dashboard/Import/Import";
import ModelsVideoCodage from "../Component/Dashboard/Default/VideoCodage/ModelsVideoCodage";
import AdmDocStatus from "../Component/Admin/Dashboard/default/AdmDocStatus/AdmDocStatus";
import MassUpdate from "../Component/Admin/Dashboard/default/AdmMassUpdate/AdmMassUpdate";
import AdmDocId from "../Component/Admin/Dashboard/default/AdmDocId/AdmDocId";
import { checkTokenExpiration } from "./RouterUtils";
import DocumentKYC from "../Component/Dashboard/Default/DocumentKYC/DocumentKYC";
import SecureIDModal from "../Component/Dashboard/Default/DocumentKYC/ActivID/SecureIDModal";
import Cookies from "js-cookie";
import DynamicModelRouter from "./DynamicModelRouter";

export default function RouterAdmin() {
  const token = Cookies.get("Token");
  const role = Cookies.get("Role");
  const location = useLocation();

  const isKycAccess =
    location.pathname.includes("/DocumentKYC") &&
    (new URLSearchParams(location.search).has("kyc") ||
      !!localStorage.getItem("kyc_waiting"));

  useEffect(() => {
    const interval = setInterval(checkTokenExpiration, 60000);
    return () => clearInterval(interval);
  }, []);

  if ((!token || role !== "superadmin") && !isKycAccess) {
    localStorage.clear();
    Object.keys(Cookies.get()).forEach((cookieName) => {
      Cookies.remove(cookieName);
    });
    return <Navigate to="/" replace />;
  }

  return (
    <Routes>
      <Route index element={<AdminHome />} />
      <Route path ="Environnement" element={<Environnement />} />
      <Route path=":configKey" element={<DynamicModelRouter />} />
      <Route path="DocStatus" element={<AdmDocStatus />} />
      <Route path="MassUpdate" element={<MassUpdate />} />
      <Route path="DocId" element={<AdmDocId />} />
      <Route path="DocView" element={<DocViewer />} />
      <Route path="Import" element={<Import />} />
      <Route path="ModelsVideoCodage" element={<ModelsVideoCodage />} />
      <Route path="/DocumentKYC" element={<DocumentKYC />} />
      <Route path="/DocumentKYC/SecureID" element={<SecureIDModal />} />

      <Route path="*" element={<Navigate to="/Admin" replace />} />
    </Routes>
  );
}
